import {installOperationFeedback} from './utils/operationFeedback'
import './assets/styles/operationFeedback.scss'
import {Modal} from 'ant-design-vue'
import {installPopupFeedback} from './utils/popupFeedback'
import {installEnterActions} from './utils/enterActions'
import {installFilterSelectWidth} from './utils/filterSelectWidth'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 2026-10-07：记录商品详情链的原列表入口，供平板顶部分类返回时复用。
import { installCatalogReturnNavigation } from './utils/catalogReturnNavigation'

import Antd from 'ant-design-vue'
// import '@/assets/styles/antd.css';
import '@/assets/styles/index.scss'
// 2026-09-30：手机网页统一为小程序式布局，仅在768px及以下生效。
import '@/assets/styles/mobile.scss'
import '@/assets/styles/mobileCheckout.scss'
import installIcons from '@/assets/icons/index'
import i18n from '@/i18n/index'
// 2026-10-18：只在展示层使用译文，所有页面共享语言状态与空间适配。
import { installLocalizedFeedback } from '@/i18n/feedback'
import { translateUi, translateUiFields, translateUiField, formatUi } from '@/i18n/display'
import '@/i18n/layout.scss'
import './router/permission'
// import { generateNewStyle } from '@/utils/theme'
// import API from 'fghis-ui'
// import 'fghis-ui/dist/css/index.css'
import Loading from '@/components/cLoading'

import CommonUi from '@/components/index'
installCatalogReturnNavigation(router, () => String(store.getters.orgId) + ':' + String(store.getters.userInfo.id || 0))
const app = createApp(App)
installEnterActions(app)
installFilterSelectWidth(app)
app.config.globalProperties.$ui = translateUi
app.config.globalProperties.$uiFields = translateUiFields
app.config.globalProperties.$uiField = translateUiField
app.config.globalProperties.$uiFormat = formatUi
installLocalizedFeedback()
installPopupFeedback(Modal,()=>JSON.stringify([router.currentRoute.value.fullPath,store.getters.token,store.getters.orgId,store.getters.userInfo?.orgId]))
installOperationFeedback(app,()=>JSON.stringify([router.currentRoute.value.fullPath,store.getters.token,store.getters.orgId,store.getters.userInfo?.id,store.getters.userInfo?.orgId]))
// console.log(CommonUi)
installIcons(app)
// API.install(app)
app.use(store).use(router).use(Antd).use(Loading).use(CommonUi).use(i18n).mount('#app')
// generateNewStyle(store.getters.theme)
